// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text[data-v-bcd77d0e] {\r\n  max-height: 40vh;\r\n  overflow: auto;\n}\n.text[data-v-bcd77d0e] pre {\r\n  margin: 0;\n}\r\n/*.row {\r\n  border: solid 1px orange;\r\n}\r\n.col {\r\n  border: solid 1px green;\r\n}*/\r\n", ""]);
// Exports
module.exports = exports;
